var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.889 4.24995L6.41014 8.54136C6.26014 8.66792 6.11952 8.71948 5.99998 8.71948C5.88045 8.71948 5.71944 8.66748 5.61116 8.56273L1.11116 4.24995C0.88625 4.03667 0.878937 3.65933 1.09428 3.45542C1.30815 3.22983 1.66569 3.2225 1.88905 3.43858L5.99998 7.37886L10.1109 3.44136C10.3336 3.22529 10.6917 3.23262 10.9057 3.4582C11.1211 3.65933 11.114 4.03667 10.889 4.24995Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrowDownIcon.5fe2eb24f22fef2802d3a64244e33961.svg";
export { ForwardRef as ReactComponent };